import { Container } from '../components';
import React, { useState } from 'react';

const values = [
    {
        title: '1', 
        current: true, 
        id: 'tab1',
        subtitle: 'With Only the Client in Mind',
        image: 'holborn',
        description: "At Holborn Assets, we start with our core premise of 'only the client in mind' and apply this to all aspects of our business. It means more than just delivering excellent products and solutions, world-class innovative service or best-in-class financial advisers; it's also about fixing things when they go wrong and ensuring you have total peace of mind.",
    },
    {
        title: '2',
        current: false,
        id: 'tab2',
        subtitle: 'Holistic Financial Planning',
        description: "You've worked hard for your money and so is important for us to keep it safe and working hard for you. We do this by looking at the bigger financial picture and taking a holistic view of the financial issues faced by us all, from cradle to grave. When it comes to proper financial planning, it's the only way to ensure we put the Right Money, in the Right Place at the Right Time.",
    },
    {
        title: '3',
        current: false,
        id: 'tab3',
        subtitle: 'Qualified and Experienced Financial Advisers',
        description: "It may seem an obvious thing to say but our clients are our business, so naturally when selecting advisers to work with only the most qualified and experienced need apply. The majority originate from the tough regulatory regime of the UK where excellence in all areas is the gold standard. However, we also have specialist financial planners from Ireland, South Africa, America, and India to cater to all your wealth management needs, whether it be sourcing you that low cost mortgage for a UK property, protecting your family with a robust life insurance package or ensuring you have saved enough money for retirement.",
    },
];

function CompanyValues() {
    const [selectedTab, setSelectedTab] = useState(values.findIndex(value => value.current));

    return (
        <Container className="CompanyValues bg-light-blue">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 py-14 mx-auto text-center">
                <div className="col-span-full lg:col-span-10 lg:col-start-2 lg:col-end-12">
                    <h2 className='font-semibold'>Company Values</h2>
                    <div className="grid grid-cols-1 pt-8">
                        <ul className="flex md:flex-wrap justify-center items-center md:space-x-24">
                            {values.map((value, index) => (
                                <li className="px-6 md:px-14" key={value.title}>
                                   <button
                                        aria-current={value.current ? "page" : undefined}
                                        className={`inline-block p-4 rounded-full w-16 h-16 font-bold text-xl ${index === selectedTab ? 'bg-white text-dark-blue' : 'bg-dark-blue text-white'}`}
                                        onClick={() => setSelectedTab(index)}
                                    >
                                        {value.title}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="col-span-full lg:col-span-12 items-center text-center">
                    <div className="grid lg:grid-cols-4 pt-4 items-center justify-center">
                        {values[selectedTab] && (
                            <div className="col-start-2 col-span-2 flex flex-col items-center justify-center">
                                <h3 className="text-center">{values[selectedTab].subtitle}</h3>
                                <p className="text-center">{values[selectedTab].description}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default CompanyValues;
